// Email Service Utility
// Simulates sending emails to users
export interface EmailResult {
  success: boolean
  messageId?: string
  error?: string
  timestamp: string
}
export interface OTPEmailData {
  recipientEmail: string
  recipientName: string
  otp: string
  expiryMinutes?: number
}
export interface PasswordResetEmailData {
  recipientEmail: string
  recipientName: string
  otp: string
  resetBy: string
  reason?: string
}
// Simulate sending OTP email for new user
export const sendNewUserOTPEmail = async (
  data: OTPEmailData,
): Promise<EmailResult> => {
  // Simulate network delay
  await new Promise((resolve) => setTimeout(resolve, 800))
  // Simulate 95% success rate
  const isSuccess = Math.random() > 0.05
  if (isSuccess) {
    return {
      success: true,
      messageId: `msg_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      timestamp: new Date().toISOString(),
    }
  } else {
    return {
      success: false,
      error: 'SMTP server connection failed',
      timestamp: new Date().toISOString(),
    }
  }
}
// Simulate sending password reset email
export const sendPasswordResetEmail = async (
  data: PasswordResetEmailData,
): Promise<EmailResult> => {
  // Simulate network delay
  await new Promise((resolve) => setTimeout(resolve, 800))
  // Simulate 95% success rate
  const isSuccess = Math.random() > 0.05
  if (isSuccess) {
    return {
      success: true,
      messageId: `msg_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      timestamp: new Date().toISOString(),
    }
  } else {
    return {
      success: false,
      error: 'Email delivery failed - recipient mailbox full',
      timestamp: new Date().toISOString(),
    }
  }
}
// Get email template preview (for testing)
export const getOTPEmailTemplate = (data: OTPEmailData): string => {
  return `
    Subject: Your OpenRemit Account - Temporary Password
    Dear ${data.recipientName},
    Welcome to OpenRemit! Your account has been created successfully.
    Your temporary password is: ${data.otp}
    For security reasons, you will be required to change this password on your first login.
    This temporary password will expire in ${data.expiryMinutes || 24} hours.
    Please keep this password confidential and do not share it with anyone.
    If you did not request this account, please contact your administrator immediately.
    Best regards,
    OpenRemit Team
  `
}
export const getPasswordResetEmailTemplate = (
  data: PasswordResetEmailData,
): string => {
  return `
    Subject: Your OpenRemit Password Has Been Reset
    Dear ${data.recipientName},
    Your password has been reset by ${data.resetBy}.
    ${data.reason ? `Reason: ${data.reason}` : ''}
    Your new temporary password is: ${data.otp}
    For security reasons, you will be required to change this password on your next login.
    If you did not request this password reset, please contact your administrator immediately.
    Best regards,
    OpenRemit Team
  `
}
